@if (!isUiTest) {
  <div>
    <div>
      <div class="hblock left">The below table shows changes to attributes for account global settings.</div>
      <div class="right">
        <fa-icon id="exportLink" [icon]="faDownload" (click)="exportHistory()" class="irb-green clickable" tooltip [tooltipTitle]="'Export'"></fa-icon>
      </div>
      <br class="clear"/>
    </div>
    <div style="height:210px;">
      <irb-inventory-grid
        [style.width]="'100%'"
        [style.height]="'100%'"
        [showSideBar]="false"
        [gridOptions]="gridOptions"
        [frameworkComponents]={}
      (gridReady)="onGridReady($event)"></irb-inventory-grid>
    </div>
  </div>
}
